/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    bool, string, object, array,
} from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CheckIcon from '@material-ui/icons/Check';

import * as recipientActions from '../../../../../../../state/ducks/Recipient/Recipient-Actions';
import * as commonSelectors from '../../../../../../../state/ducks/Common/Common-Selectors';

// pass a prop into breadcrumb that signals that a subheading is active
const styles = (theme) => ({
    breadcrumbRow: {
        margin: '12px 0 0',
    },
    inactive: {
        padding: '0px 18px 10px 6px',
        borderBottom: '2px solid transparent',
        color: theme.palette.colorNeutral60,
        fontWeight: '600',
        cursor: 'pointer',
        width: '100%',
        fontSize: '13px',
        display: 'flex',
        textDecoration: 'none',
        justifyContent: 'center',
        alignItems: 'center',
        '& span': {
            verticalAlign: 'top',
            display: 'inline-block',
        },
    },
    active: {
        padding: '0px 18px 10px 6px',
        width: '100%',
        color: theme.palette.colorNeutral80,
        fontSize: '13px',
        display: 'flex',
        textDecoration: 'none',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: '600',
        borderBottom: `2px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        cursor: 'pointer',
        '& span': {
            verticalAlign: 'top',
            display: 'inline-block',
        },
    },
    prefixIcon: {
        width: '24px',
        height: '24px',
        lineHeight: '16px',
        fontSize: '16px',
        margin: '4px 6px',
        borderRadius: '50%',
        padding: '3px 6px 5px 3px',
        display: 'inline-block',
        backgroundColor: theme.palette.primaryButton,
    },
    filledCheckMark: {
        color: theme.palette.white,
        fontSize: '18px !important',
    },
    prefixNumber: {
        backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
        color: theme.palette.white,
        width: '24px',
        height: '24px',
        lineHeight: '16px',
        fontSize: '16px',
        margin: '4px 6px',
        borderRadius: '50%',
        padding: '4px',
        display: 'inline-block',
    },
});

const BreadcrumbMobile = ({
    classes, active, orderId,
    continueToPayment, continueToReview, orderItemHasError,
}) => {
    const getPrefix = (index, isIcon) => (
        <span className={isIcon ? classes.prefixIcon : classes.prefixNumber}>
            {isIcon ? <CheckIcon className={classes.filledCheckMark} /> : index + 1}
        </span>
    );

    const continueToReviewPage =  !(orderItemHasError?.length > 0) && continueToReview;
    const continueToPaymentPage =  !(orderItemHasError?.length > 0) && continueToPayment;

    return (
        <Grid container className={classes.breadcrumbRow}>
            <Grid item xs={6} align="center">
                <Link
                    className={active === 'shipping' ? classes.active : classes.inactive}
                    to={(continueToPaymentPage ? `/checkout/shipping/${orderId}` : '#')}
                    data-test="checkout-breadcrumb-shipping"
                >
                    {getPrefix(0, continueToPaymentPage)}
                    <span>Shipping</span>
                </Link>
            </Grid>
            <Grid item xs={6} align="center">
                <Link
                    className={active === 'payment' ? classes.active : classes.inactive}
                    to={(continueToPaymentPage || continueToReviewPage ? `/checkout/payment/${orderId}` : '#')}
                >
                    {getPrefix(1, continueToReviewPage)}
                    <span>Payment & Review</span>
                </Link>
            </Grid>
        </Grid>
    );
};

BreadcrumbMobile.propTypes = {
    classes: object.isRequired,
    active: string.isRequired,
    orderId: string.isRequired,
    continueToPayment: bool.isRequired,
    continueToReview: bool.isRequired,
    orderItemHasError: array.isRequired,
};

const mapStateToProps = (state) => {
    if (!state?.checkout) {
        return ({
            orderId: '',
            orderItemHasError: [],
            cartItems: '',
            continueToPayment: '',
            continueToReview: '',
        });
    }

    return ({
        orderId: commonSelectors.getOrderId(state),
        orderItemHasError: commonSelectors.getOrderItemsWithError(state),
        cartItems: commonSelectors.getRecipientsExcludePassport(state),
        continueToPayment: commonSelectors.continueToPayment(state),
        continueToReview: commonSelectors.getReviewOrderStatus(state),
    });
};

const mapDispatchToProps = (dispatch) => ({
    triggerValidateOrder: bindActionCreators(recipientActions.callToTriggerValidateOrder, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(BreadcrumbMobile));
